import * as React from "react";
import type { SvyIconProps } from "./SvyIcon.interface";

export const SvyIcon = React.forwardRef<HTMLElement, SvyIconProps>(({ icon, className, ...rest }, ref) => (
    <span
        ref={ref}
        aria-hidden="true"
        data-testid="svy-icon"
        {...rest}
        className={`${className ? `${className} ` : ""}ri-${icon}`}
    />
));

SvyIcon.displayName = "SvyIcon";
